import React from 'react';

const ACTION_CARDS = [
  {
    key: 'approving',
    countKey: 'pendingApprovalCount',
    border: '#FBCFE8',
    bg: '#FFF1F5',
    numColor: '#9F1239',
    labelColor: '#BE185D',
    label: 'pending approvals',
    cta: 'Tap to review →',
    testId: 'admin-quick-action-approving',
  },
  {
    key: 'support',
    countKey: 'supportOpenCount',
    border: '#FCA5A5',
    bg: '#FEF2F2',
    numColor: '#991B1B',
    labelColor: '#DC2626',
    label: 'open support threads',
    cta: 'Tap to reply →',
    testId: 'admin-quick-action-support',
  },
  {
    key: 'reports',
    countKey: 'reportsOpenCount',
    border: '#FCA5A5',
    bg: '#FFF7ED',
    numColor: '#9A3412',
    labelColor: '#C2410C',
    label: 'open reports',
    cta: 'Tap to review →',
    testId: 'admin-quick-action-reports',
  },
  {
    key: 'disputes',
    countKey: 'disputesOpenCount',
    border: '#DDD6FE',
    bg: '#F5F3FF',
    numColor: '#4C1D95',
    labelColor: '#6D28D9',
    label: 'open disputes',
    cta: 'Tap to resolve →',
    testId: 'admin-quick-action-disputes',
  },
];

export const AdminMobileQuickActions = ({
  pendingApprovalCount,
  supportOpenCount,
  reportsOpenCount,
  disputesOpenCount,
  onNavigateTab,
}) => {
  const counts = { pendingApprovalCount, supportOpenCount, reportsOpenCount, disputesOpenCount };
  const visible = ACTION_CARDS.filter((c) => counts[c.countKey] > 0);
  if (!visible.length) return null;

  return (
    <div
      data-testid="admin-mobile-quick-actions"
      style={{
        display: 'grid',
        gridTemplateColumns: visible.length === 1 ? '1fr' : 'repeat(2, minmax(0, 1fr))',
        gap: 10,
        marginBottom: 14,
      }}
    >
      {visible.map((card) => (
        <button
          key={card.key}
          onClick={() => onNavigateTab(card.key)}
          data-testid={card.testId}
          style={{
            display: 'flex', flexDirection: 'column', gap: 2,
            padding: '12px 14px', borderRadius: 16,
            border: `1px solid ${card.border}`,
            background: card.bg,
            cursor: 'pointer', textAlign: 'left',
            fontFamily: "'Manrope', sans-serif",
            minWidth: 0,
            boxShadow: '0 1px 2px rgba(15,17,21,0.03)',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'baseline', gap: 6, minWidth: 0 }}>
            <span style={{ fontSize: 22, fontWeight: 800, color: card.numColor, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
              {counts[card.countKey]}
            </span>
            <span style={{
              fontSize: 11.5, fontWeight: 600, color: card.labelColor,
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0,
            }}>
              {card.label}
            </span>
          </span>
          <span style={{ fontSize: 10.5, color: card.numColor, fontWeight: 700, marginTop: 4, letterSpacing: 0.2 }}>{card.cta}</span>
        </button>
      ))}
    </div>
  );
};
